import { getbyprojectno, getbyprojectnoWPS, checkValidWPS } from "../../../Services/wps_groove-services";
import { checkProcessAdded as commonCheckProcessAdded, checkDuplicateProcess as commonCheckDuplicateProcess, validateFirstPageFields } from "../../utility/common/TransactionComponents/TransactionValidationUtils";

export const GrooveType = ["Groove", "Tubesheet", "Overlay"];

export const checkProcessAdded = (detailObj) => {
  // Ensure detailObj is an array
  if (!Array.isArray(detailObj)) {
    console.warn('detailObj is not an array in checkProcessAdded:', detailObj);
    return false;
  }

  const wpsType = detailObj[0]?.wld_WPSType;
  return commonCheckProcessAdded(detailObj, {
    processField: 'WPSD_Process',
    typeField: 'WPSD_Type',
    fNoField: 'WPSD_FM_FNo',
    weldLayerField: wpsType === 'Overlay' ? 'WPSH_WeldLayer' : undefined,
    wpsType,
    maxRows: 3
  });
};

export const checkduplicateProcess = (detailObj) => {
  // Ensure detailObj is an array
  if (!Array.isArray(detailObj)) {
    console.warn('detailObj is not an array in checkduplicateProcess:', detailObj);
    return false;
  }

  return commonCheckDuplicateProcess(detailObj, {
    processField: 'WPSD_Process',
    typeField: 'WPSD_Type'
  });
};

export const checkFirstPageValidation = (headerObj, setConsumError, setFluxError, setSupFilterError) => {
  const fields = ['ANo', 'ChemicalAnalysis_TradeName', 'Classification', 'FNo', 'SFA'];

  let prefixRadioMap = [
    { prefix: "WPSH_Flux_", radio: "WPSH_fluxRadio", err: setFluxError },
    { prefix: "WPSH_SupFiller_", radio: "WPSH_filterRadio", err: setSupFilterError }
  ];

  if (headerObj.wld_WPSType === "Groove") {
    prefixRadioMap = [
      { prefix: "WPSH_ConsuInsert_", radio: "WPSH_consumRadio", err: setConsumError },
      { prefix: "WPSH_Flux_", radio: "WPSH_fluxRadio", err: setFluxError },
      { prefix: "WPSH_SupFiller_", radio: "WPSH_filterRadio", err: setSupFilterError }
    ];
  }

  let hasError = false;

  prefixRadioMap.forEach(({ prefix, radio, err }) => {
    const fieldValues = {
      ANo: headerObj[prefix + 'ANo'],
      ChemicalAnalysis_TradeName: headerObj[prefix + 'ChemicalAnalysis_TradeName'],
      Classification: headerObj[prefix + 'Classification'],
      FNo: headerObj[prefix + 'FNo'],
      SFA: headerObj[prefix + 'SFA']
    };
    console.log(`Validating ${prefix}:`, {
      radioValue: headerObj[radio],
      fieldValues,
      prefix,
      radio,
      err
    });

    const result = validateFirstPageFields(headerObj[radio] || "Required", fieldValues, err);

    if (!result) hasError = true;
  });
  console.log("Has Error", hasError)
  return { isError: hasError };
};

export const checkTubeProcessAdded = (detailObj) => {
  return commonCheckProcessAdded(detailObj, {
    processField: 'WPSD_Process',
    typeField: 'WPSD_FM_SFA',
    fNoField: 'WPSD_FM_FNo',
    maxRows: 1
  });
};

export const isDuplicate = async (proj, wpsno) => {
  let results = [],
    checkarray = [];
  for (let groove of GrooveType) {
    let result = await getbyprojectno(groove, proj, wpsno).catch((error) => {
      console.log("Error isDuplicate", error);
      return [];
    });
    if (result != undefined) results.push(result);
  }
  for (let result of results) {
    let check = await Promise.resolve(result);
    if (check && Array.isArray(check)) {
      checkarray = [...checkarray, ...check];
    }
  }

  return checkarray.length > 0;
};

export const getWPS = async (proj) => {
  let results = [],
    checkarray = [];
  for (let groove of GrooveType) {

    let result = getbyprojectnoWPS(groove, proj).catch((error) => {
      console.log("Error isDuplicate", error);
    });


    if (result != undefined) results.push(result);
  }
  for (let result of results) {
    let check = await Promise.resolve(result);
    checkarray = [...checkarray, ...check];
  }

  return checkarray;
};



export const checkWPSinArray = async (wpsno) => {

  let results = [],
    checkarray = [];

  for (let groove of GrooveType) {
    let groovetype = { GrooveType: groove };
    let request = { wpsno, groovetype };

    let result = checkValidWPS(request).catch((error) => {
      console.log("Error getWPSbyWPSNo", error);
    });


    if (result != undefined) results.push(result);
  }
  for (let result of results) {
    let check = await Promise.resolve(result);
    if (check != undefined) checkarray = [...checkarray, ...check];
  }

  return Promise.resolve(checkarray);
};



